module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading-bar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('modal'), _vm._v(" "), _c('div', {
    staticClass: "notifications-list"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "p"
    }
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('span', {
      key: notification.type,
      class: ['list-item ', 'alert', ("alert-" + (notification.type))]
    }, [_vm._v("\n        " + _vm._s(notification.text) + "\n      ")])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b8beca0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1489
// module chunks = 4